import { Button } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import apiJurados from "../../../api/Jurados/api-jurados";
import { Footer } from "../../../components/Landing/Footer";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { useEducacionNoFormal } from "../../../hooks/useEducacionNoFormal";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { juradoEditar, menuJuradoAction } from "../../../redux/actions/juradosAction";
import { RootState } from "../../../redux/reducers";
import { openNotification } from "../../../utils/Notifactions";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { FormNoFormal } from "./components/form-noformal.view";
import { TableNoFormal } from "./components/table-noformal.view";
import "./educacion-noformal.style.scss";
export const EducacionNoFormal = () => {
  const { menuJurado } = useSelector(
    (state: RootState) => state.jurado
  );

  const idJurado = localStorage.getItem("idJurado");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();
  const {
    educacionNoFormal,
    guardarFormulario,
    setEducacionNoFormal,
    guardarArchivo,
    formRef,
    resetForm,
    eduacionFormalArray,
    setEduacionFormalArray,
  } = useEducacionNoFormal();
  useEffect(() => {
    setEduacionFormalArray([]);
    cargarEducacionNoFormal();
    getConvocatoriaPersistente();
  }, []);

  const { estadoFormulario } = useParams();

  const cargarEducacionNoFormal = async () => {
    const educacion_no_formal = await apiJurados.obtenerEducacionNoFormal(
      idJurado
    );

    if (educacion_no_formal && educacion_no_formal.length > 0) {
      setEducacionNoFormal(educacion_no_formal);
      return setEduacionFormalArray(educacion_no_formal);
    }
  };
  const nextScreen = async () => {
    if (eduacionFormalArray.length === 0) {
      return openNotification({
        titulo: "Error",
        descripcion: "Debe enviar al menos una educación no formal",
        placement: "bottomRight",
      });
    }
    try {
      setLoading(true);
      await apiJurados.putEducacionNoFormal(
        eduacionFormalArray,
        Number(idJurado)
      );
      if (estadoFormulario != "" && estadoFormulario != undefined) {
        dispatch(juradoEditar(false));
        setLoading(false);
        return navigate("/usuario/estadosFormulario");
      }
      if (menuJurado) {
        dispatch(menuJuradoAction(false));
        setLoading(false);
        return navigate("/usuario/MenuJurado");
      }
      setLoading(false);
      return navigate("/usuario/agregarExperienciaProfesionalJurado");
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Mi Educación No Formal" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <div className="row">
          <TextoInicialJurados
            TituloSpan="Genial ya casi terminamos, Agrega tu educacion no formal."
            TitulosinSpan=""
          />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="row mt-4 g-1 pe-0">
              <div className="col-1 ms-1 me-0 d-flex justify-content-center align-content-center font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion numero-jurados">
                4
              </div>
              <h2 className="col ps-0 ms-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
                Agregar Educación No Formal
              </h2>
            </div>
          </div>
          <div className="col-12">
            <FormNoFormal
              educacionNoFormal={educacionNoFormal}
              guardarFormulario={guardarFormulario}
              setEducacionNoFormal={setEducacionNoFormal}
              guardarArchivo={guardarArchivo}
              formRef={formRef}
              resetForm={resetForm}
            />
          </div>
          <div className="col-12">
            <TableNoFormal
              eduacionFormalArray={eduacionFormalArray}
              setEduacionFormalArray={setEduacionFormalArray}
            />
          </div>
          <nav
            className="col bg-white"
            style={{
              justifyContent: "center",
              position: "sticky",
              bottom: 0,
              paddingBottom: "0%",
              zIndex: 1000,
            }}
          >
            <div className="justify-content-end">
              <div className="col justify-content-flex-end">
                <Button className="button-blanco-radius" style={{ marginRight: '10px' }} onClick={() => { return navigate('/usuario/educacionFormal') }}>
                  Atrás
                </Button>
                <Button
                  className="button-azul-radius"
                  onClick={nextScreen}
                  disabled={loading}
                >
                  Continuar
                  {loading && (
                    <i
                      className="fa fa-spinner fa-spin"
                      style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                    />
                  )}
                </Button>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <Footer />
    </>
  );
};
